import {
  Field,
  FieldLabel,
  FieldControl,
  FieldFooter,
  FieldNote,
  FieldContextProvider,
} from './src/Field';

const _Field = Object.assign(Field, {
  Control: FieldControl,
  Label: FieldLabel,
  Footer: FieldFooter,
  Note: FieldNote,
  Context: FieldContextProvider,
});

export { _Field as Field };
export { type FieldProps } from './src/Field';
